import {
  ExamsCaptureTabsConfigSchema,
  type ExamsCaptureTabsConfig,
} from '../../domain/entities/tabs.entity';
import type { TabsConfigDatasource } from '../repositories/tabs-config.repository.impl';

/** A chave do Remote Config com as abas de todas as provas e anos. */
export const TABS_REMOTE_CONFIG_KEY = 'EXAMS_CAPTURE_TABS';

/**
 * Intervalo mínimo entre buscas no Remote Config: **1 hora**, como no ENAMED.
 * Uma mudança publicada no console aparece para quem recarregar a página em até
 * uma hora; o padrão do SDK (12 horas) seria lento demais para virar uma aba no
 * dia da prova.
 */
const MIN_FETCH_INTERVAL_MS = 60 * 60 * 1000;

/**
 * As abas do painel no Remote Config (`EXAMS_CAPTURE_TABS`), no projeto do
 * Firebase da Primum — o mesmo do login.
 *
 * **Nada aqui rejeita.** Falha de rede, chave ausente ou JSON fora do contrato
 * viram `{}`, e quem resolve as abas cai no piso seguro (só o Ensaio). Um
 * painel sem aba por causa de uma vírgula no console seria pior.
 */
export class TabsRemoteConfigDatasource implements TabsConfigDatasource {
  async getConfig(): Promise<ExamsCaptureTabsConfig> {
    // Sob demanda: o SDK só carrega quando o painel é aberto de verdade.
    const [{ firebaseApp }, rc] = await Promise.all([
      import('@/lib/firebase'),
      import('firebase/remote-config'),
    ]);
    const remoteConfig = rc.getRemoteConfig(firebaseApp);
    remoteConfig.settings.minimumFetchIntervalMillis = MIN_FETCH_INTERVAL_MS;

    try {
      // Pode falhar (offline, cota): o `getValue` abaixo ainda devolve o
      // último valor ativado, se houver.
      await rc.fetchAndActivate(remoteConfig);
    } catch {
      console.error('[abas] Remote Config indisponível, seguindo com o local');
    }

    const raw = rc.getValue(remoteConfig, TABS_REMOTE_CONFIG_KEY).asString();
    if (!raw) return {};
    try {
      return ExamsCaptureTabsConfigSchema.parse(JSON.parse(raw));
    } catch {
      console.error(
        `[abas] valor inválido em ${TABS_REMOTE_CONFIG_KEY}; usando só o Ensaio`,
      );
      return {};
    }
  }
}
